export enum MaintenanceStatus {
  Active = 'MAINTENANCE_ACTIVE',
  Planned = 'MAINTENANCE_PLANNED',
}
